const translations = {
  // Navbar
  nav_home: 'Home',
  nav_products: 'Products',
  nav_contact: 'Contact Us',
  nav_quote: 'Get a Quote',

  // Hero
  hero_tagline: 'MAX SailS',
  hero_title: 'Welcome',
  hero_subtitle: 'Selling quality sails at attractive prices — crafted for sailors who demand value & quality.',
  hero_cta_quote: 'Get a Quote',
  hero_cta_products: 'Products',

  // About Teaser
  about_label: 'Products',
  about_title_1: 'Supplier of',
  about_title_2: 'Sails',
  about_p1: 'MAX Sails Canada is happy to serve the global sailing community. We combine traditional craftsmanship with modern materials to deliver sails that perform beautifully and that will last for years.',
  about_p2: 'Whether you\'re a weekend cruiser or a competitive racer, we can supply the appropriate sail for your boat.',
  about_p3: 'Our customers range from single end users to sailing schools, clubs, hotels & resorts around the world.',
  about_cta: 'View Our Products',

  // Why Us
  whyus_label: 'Why Choose Us',
  whyus_title_1: 'Built on',
  whyus_title_2: 'Craftsmanship',
  whyus_desc: 'When you choose sails from MAX Sails Canada, you\'re choosing a team that genuinely cares about your sailing experience.',
  whyus_email_btn: 'Email Us Today',
  whyus_r1_title: 'Quality Materials',
  whyus_r1_desc: 'Our sails use premium materials and hardware to ensure durability, longevity and performance.',
  whyus_r2_title: 'Attractive Pricing',
  whyus_r2_desc: 'Quality sails don\'t have to break the bank. We offer competitive pricing without compromising on craftsmanship.',
  whyus_r3_title: 'Fast Turnaround',
  whyus_r3_desc: 'We respect your sailing season. Our team works efficiently to get your sails to you when you need them.',

  // Contact Banner
  banner_title: 'Ready to set sail?',
  banner_subtitle: 'Get in touch with us today for a free quote on your next sail.',
  banner_send: 'Send a Message',

  // Products Page
  products_hero_label: 'MAX Sails Canada',
  products_hero_title: 'Our Products',
  products_hero_subtitle: 'Quality sails crafted for every sailor — from weekend cruisers to competitive racers.',
  products_section_label: 'What We Offer',
  products_section_title: 'Sails for Most Boats & Budgets',
  products_section_desc: 'Every sail we supply is manufactured to exact specifications.',
  products_cta: 'Request a Quote',

  // Product cards
  prod1_cat: 'Mainsails',
  prod1_title: 'Performance Mainsail',
  prod1_desc: 'Built for speed and durability. Our mainsails are cut with precision for optimal shape retention across a wide wind range — from light air to heavy breeze.',
  prod1_tag1: 'Racing',
  prod1_tag2: 'Cruising',

  prod2_cat: 'Headsails',
  prod2_title: 'Genoa & Jib',
  prod2_desc: 'From light-air drifters to heavy-weather working jibs, we craft headsails that balance power and control for every point of sail.',
  prod2_tag1: 'Genoa',
  prod2_tag2: 'Jib',
  prod2_tag3: 'Furling',

  prod3_cat: 'Spinnakers',
  prod3_title: 'Asymmetric Spinnaker',
  prod3_desc: 'Maximize your downwind performance with a custom-cut asymmetric spinnaker. Lightweight, vibrant, and built to fly.',
  prod3_tag1: 'Downwind',
  prod3_tag2: 'Racing',

  prod4_cat: 'Cruising Sails',
  prod4_title: 'Cruising Sail Set',
  prod4_desc: 'Complete sail packages for cruising sailors. Tough, reliable, and easy to handle — designed for long passages and comfortable sailing.',
  prod4_tag1: 'Cruising',
  prod4_tag2: 'Dacron',

  prod5_cat: 'Storm Sails',
  prod5_title: 'Storm Trysail & Staysail',
  prod5_desc: 'When conditions get serious, you need sails you can trust. Our storm sails are built from heavy-duty cloth with reinforced corners and robust hardware.',
  prod5_tag1: 'Safety',
  prod5_tag2: 'Heavy Weather',

  // ILCA Section
  ilca_label: 'HIGH VOLUME Inventory',
  ilca_title: 'ILCA / Laser Sail Inventory',
  ilca_subtitle: 'We stock all three ILCA rig sizes — from youth lightweight rigs to the full competitive standard rig.',
  ilca_rec_use: 'Recommended Use',
  ilca_mat_weight: 'Material Weight',
  ilca_badge_youth: 'Youth Rig',
  ilca_badge_radial: 'Radial Rig',
  ilca_badge_full: 'Full Rig',
  ilca_use_youth: 'Youth / Lightweight',
  ilca_use_mid: 'Mid-range / Standard',
  ilca_use_full: 'Full Rig / Competitive',

  ilca_training_title: 'Specific Training Sails',
  ilca_training_desc: 'Training sails are a high-volume item because they allow sailors to save their expensive "Class Legal" sails for race days.',
  ilca_t1_label: 'ILCA-4 Training Sails (3.8 oz)',
  ilca_t1_desc: 'High durability for youth programs.',
  ilca_t2_label: 'ILCA-6 Training Sails (3.8 oz)',
  ilca_t2_desc: 'The most common "Radial" size for club racing and practice.',
  ilca_t3_label: 'ILCA-7 Training Sails (4.9 oz)',
  ilca_t3_desc: 'The heavier "Standard" rig cloth, built to handle the higher tension of the full-size mast.',

  // Contact Page
  contact_hero_label: 'Get In Touch',
  contact_hero_title: 'Contact Us',
  contact_reach_label: 'Reach Us',
  contact_reach_title_1: 'We\'d Love to',
  contact_reach_title_2: 'Hear From You',
  contact_reach_desc: 'Have a question about a sail, need a quote? Drop us a message or give us a call\u00a0',
  contact_phone_label: 'Phone',
  contact_email_label: 'Email',
  contact_fname: 'First Name',
  contact_lname: 'Last Name',
  contact_email_field: 'Email',
  contact_phone_field: 'Phone (optional)',
  contact_service: 'Service Needed',
  contact_service_placeholder: 'Select a service...',
  contact_service_1: 'Custom Sail',
  contact_service_2: 'In Stock Sails',
  contact_service_3: 'Volume Order',
  contact_message: 'Message',
  contact_message_placeholder: 'Tell us about your sail project or question...',
  contact_submit: 'Send Message',
  contact_sending: 'Sending...',
  contact_success_title: 'Message Sent!',
  contact_success_desc: 'Thanks for reaching out. We\'ll get back to you as soon as possible.',

  // Custom lettering
  custom_label: 'Special Orders',
  custom_title: 'Custom Lettering & Numbering',
  custom_desc: 'Personalize your sail with custom lettering and numbering — available on special order. Sail numbers, boat names, club logos and more, applied with precision for a professional finish.',
  custom_cta: 'Request a Custom Order',

  // Footer
  footer_desc: 'Providing quality sails at competitive prices.\u00a0',
  footer_nav_title: 'Navigation',
  footer_contact_title: 'Contact',
  footer_copyright: '© 2026 MAX Sails Canada. All rights reserved.',
};

export default translations;
